import { z } from 'zod'

export const ReactivationReasonSchema = z.enum(['expand-coverage', 'retry-warnings', 'scanner-update', 'retest'])
export const ReactivationRequestSchema = z.object({
  project_id: z.string().min(1),
  request_id: z.string().uuid(),
  reason: ReactivationReasonSchema,
  focus: z.string().trim().min(1).max(2000),
})
export const SecurityHistoryFindingSchema = z.object({ id: z.string(), title: z.string(), severity: z.string() })
export const SecuritySnapshotSchema = z.object({
  session_id: z.string().nullable(),
  session_ids: z.array(z.string()).default([]),
  findings: z.array(SecurityHistoryFindingSchema),
  warnings: z.array(z.string()),
  complete: z.boolean(),
})
export const SecurityDeltaSchema = z.object({
  new_findings: z.array(SecurityHistoryFindingSchema),
  new_warnings: z.array(z.string()),
  fixed_warnings: z.array(z.string()).default([]),
})
const TimestampSchema = z.union([z.string(), z.date().transform(date => date.toISOString())])
export const SecurityReactivationSchema = z.object({
  id: z.string(), project_id: z.string(), session_id: z.string().nullable(), reason: ReactivationReasonSchema,
  focus: z.string(), initiated_by: z.string(), scanner_version: z.string(),
  status: z.enum(['running', 'completed', 'incomplete']),
  started_at: TimestampSchema, completed_at: TimestampSchema.nullable(),
  baseline: SecuritySnapshotSchema, result: SecuritySnapshotSchema.nullable(), delta: SecurityDeltaSchema.nullable(),
})
export const SecurityHistoryEntrySchema = SecurityReactivationSchema.pick({
  id: true, project_id: true, session_id: true, reason: true, status: true,
  started_at: true, completed_at: true, result: true, delta: true,
})
export const ReactivationEmailSchema = z.object({
  id: z.string(), reactivation_id: z.string(), project_id: z.string(), project_name: z.string(),
  recipient: z.string(), recipient_user_id: z.string(), subject: z.string(), text_body: z.string(),
  status: z.enum(['pending', 'sending', 'sent', 'failed', 'dismissed']),
  created_at: TimestampSchema, sent_at: TimestampSchema.nullable(), error: z.string().nullable(),
  last_attempt_at: TimestampSchema.nullable(), sent_by: z.string().nullable(),
})
export const ReactivationEmailsResponseSchema = z.object({ items: z.array(ReactivationEmailSchema), has_more: z.boolean() })
export const ReactivationEmailActionSchema = z.object({ id: z.string(), action: z.enum(['send', 'dismiss', 'refresh']) })
export const ReactivationEmailActionResponseSchema = z.object({ ok: z.boolean(), error: z.string().optional() })
export type SecuritySnapshot = z.infer<typeof SecuritySnapshotSchema>
export type SecurityDelta = z.infer<typeof SecurityDeltaSchema>
export type SecurityReactivation = z.infer<typeof SecurityReactivationSchema>
export type ReactivationRequest = z.infer<typeof ReactivationRequestSchema>
